import "./index.scss";
import { BreadcrumbProps } from "./types";
import { Link } from "gatsby";
import { truncateString } from "helpers/generic";
import React from "react";

const regexSplitURL = /-/g;

const LIMIT_CHARS = 27;

const Breadcrumb = ({ crumbs }: BreadcrumbProps) => {
  const currentCrumbs = [...crumbs];
  currentCrumbs.splice(0, 2);
  const lastIndex = currentCrumbs.length - 1;
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <div className="breadcrumb__wrapper wrapContentV2 wrapContentV2-md-xl wrapContentV2-lg-xl wrapContentV2-xl-xl">
        <ol className="breadcrumb__list">
          {currentCrumbs.map((item, i) => {
            const customCrumbLabel = item.crumbLabel
              .toLowerCase()
              .replace(regexSplitURL, " ");
            const truncateCustomCrumbLabel = truncateString(
              customCrumbLabel,
              LIMIT_CHARS,
            );
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li className="breadcrumb__item" data-testid="breadlist" key={i}>
                {i !== lastIndex ? (
                  <Link
                    className="breadcrumb__link"
                    to={item.pathname}
                    area-label={customCrumbLabel}
                    title={customCrumbLabel}
                  >
                    {truncateCustomCrumbLabel}
                  </Link>
                ) : (
                  <span
                    className="breadcrumb__link breadcrumb__link--active"
                    aria-current="page"
                  >
                    {truncateCustomCrumbLabel}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
